import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormElementBase } from '../form-element-base';

@Component({
  selector: 'radio-button',
  templateUrl: './radio-btn.component.html',
  styleUrls: ['./radio-btn.component.css']
})
export class RadioBtnComponent extends FormElementBase {
  constructor() {
    super();
  }
}
